<template>
  <callback-status variant="failed" />
</template>

<script>
import CallbackStatus from './CallbackStatus.vue'

export default {
  components: { CallbackStatus },
}
</script>
